import cn from 'classnames';
// Helpers
import { joinStrings, AddressCardProps } from 'helpers/address';
// UI
import Text from 'ui3/Text/Text';
// Components
import { showToast } from 'components/common/Toast/Toast';
// Styles
import styles from './AddressCard.module.scss';

const AddressCard = ({
  address,
  isSelected = false,
  showPhoneAndEmail = false,
  title,
  actions,
  showToastOnSelect = true,
  className,
  onSelect,
}: AddressCardProps) => {
  const {
    firstName,
    lastName,
    country,
    state,
    city,
    addressLine1,
    addressLine2,
    zipCode,
    phone,
    email,
    isDefault,
  } = address;
  const handleAddressSelect = () => {
    onSelect(address);

    if (showToastOnSelect) {
      showToast({
        type: 'success',
        message: 'Shipping address saved.',
      });
    }
  };

  const fullName = `${firstName} ${lastName}`;

  const cityStateCode = joinStrings([city, state, zipCode]);
  const addressLine = joinStrings([addressLine1, addressLine2]);

  const addressListing = [addressLine, cityStateCode, country].filter(Boolean);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleAddressSelect}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleAddressSelect();
        }
      }}
      className={cn(styles.root, className, {
        [styles.isSelected]: isSelected,
        [styles.isDefault]: isDefault,
      })}
    >
      <div className={styles.header}>
        <div className={styles.headerMain}>
          <Text variant="body2Regular">{title || fullName}</Text>
          {isDefault && <span className={styles.defaultBadge}>Default</span>}
        </div>

        {actions && <div className={styles.actions}>{actions}</div>}
      </div>

      {title && (
        <Text variant="body2Regular" color="lights-high">
          {fullName}
        </Text>
      )}

      <Text variant="body2Regular" color="lights-low">
        {addressListing.join(', ')}
      </Text>

      {showPhoneAndEmail && (
        <>
          <Text variant="body2Regular" color="lights-low">
            {email}
          </Text>

          <Text variant="body2Regular" color="lights-low">
            {phone}
          </Text>
        </>
      )}
    </div>
  );
};

export default AddressCard;
